<template>
    <div class="quote-status-goal-modal">
        <GoalModal
            :is-open="isOpen"
            :goal-tip-link="toolTipLink"
            :goal-tip-text="$t('funnel.edit.quotes.tip.text')"
            :summary-text="$t('funnel.edit.quites.summary')"
            :title="$t('funnel.edit.quotes.title')"
            @update-config="updateConfig"
            @close-modal="closeModal"
        >
            <template #goalParameters>
                <DsMultiselect
                    v-model="quoteStatus"
                    label-prop="name"
                    value-prop="id"
                    help-text
                    required
                    bind-value-only
                    help-text-prop="additional"
                    class="quote-status"
                    :placeholder="$t('funnel.edit.quotes.label')"
                    :options="options"
                    :force-invalid="emptyQuoteStatus"
                >
                    <template #help>
                        <span v-if="emptyQuoteStatus" data-qa="invalid-quote-status">
                            {{ $t('global.field.required') }}
                        </span>
                    </template>
                </DsMultiselect>
            </template>
        </GoalModal>
    </div>
</template>

<script>
import GoalModal from '../goalModal/GoalModal.vue';

export default {
    components: {
        GoalModal,
    },

    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        appInfo: {
            type: Object,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    quoteStatus: '',
                },
            }),
        },
    },
    emits: ['close-modal', 'update-cell-value'],
    data() {
        return {
            quoteStatus: this.cell?.value?.quoteStatus ?? '',
            emptyQuoteStatus: false,
        };
    },

    computed: {
        isSpaApp() {
            return this.appInfo?.appEditionFlags?.spaApp;
        },

        toolTipLink() {
            return this.isSpaApp ? this.$t('funnel.edit.quotes.tip.url.keap') : this.$t('funnel.edit.quotes.tip.url.classic');
        },

        options() {
            const options = [];

            options.push({ id: 'sent', name: this.$t('funnel.edit.quotes.options.sent'), additional: '' });
            options.push({ id: 'viewed', name: this.$t('funnel.edit.quotes.options.viewed'), additional: '' });

            if (this.isSpaApp) {
                options.push({ id: 'accepted', name: this.$t('funnel.edit.quotes.options.accepted'), additional: '' });
            } else {
                options.push({ id: 'declined', name: this.$t('funnel.edit.quotes.options.declined'), additional: '' });
                options.push({ id: 'accepted', name: this.$t('funnel.edit.quotes.options.accepted'), additional: this.$t('funnel.edit.quotes.options.accepted.additional') });
                options.push({ id: 'payLater', name: this.$t('funnel.edit.quotes.options.accepted'), additional: this.$t('funnel.edit.quotes.options.payLater.additional') });
                options.push({ id: 'paid', name: this.$t('funnel.edit.quotes.options.paid'), additional: '' });
            }

            return options;
        },

        allowSave() {
            return !!this.quoteStatus;
        },
    },

    methods: {
        updateConfig() {
            if (this.allowSave) {
                const cell = { ...this.cell };

                cell.value = cell.value || {};
                cell.value.quoteStatus = this.quoteStatus;

                this.$emit('update-cell-value', { cell });
            } else {
                this.emptyQuoteStatus = true;
            }
        },

        closeModal() {
            this.$emit('close-modal');
        },
    },
};
</script>

<style lang="scss" scoped>
div.quote-status > div > div.dropdown-reference > div > div.multiselect-tags > span > label {
    padding-top: 0px;
}

div.quote-status > div.dropdown >  .dropdown-menu.open {
    width: 100%;
}
</style>
